import React from 'react';
import { Box, Typography, Grid, Button, Paper, IconButton } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import BusinessIcon from '@mui/icons-material/Business';
import {
    ArrowBack as ArrowBackIcon
} from '@mui/icons-material';
import {

    PRIVATE_USER_DELEGATION,
    PRIVATE_USER_LIST_DELEGATION_SERVICE,
    PRIVATE_USER_LIST_SERVICE_COMPANY,
    PRIVATE_USER_LIST_UNION_DELEGATION_SERVICE,

} from 'DelegationService/DelegationService/Application/Constants/PathsConstants.js';
import { DELEGATION_SERVICE } from 'User/Application/Constants/PathsConstant';
import { GESTOR_DELEGACIONES_SERVICIOS } from 'Shared/Security/Application/Constants/PermissionsConstant';
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';


export default function ServiceManagmentLandingView() {
    // Apilar en una columna cuando el viewport sea <= 1000px
    const isStack = useMediaQuery('(max-width:1000px)');
    const { checkPermission } = useAuthContext();
    const navigate = useNavigate();
    const [hasAdminPermission,setHasAdminPermission] = React.useState(false);
    console.log(hasAdminPermission);
    React.useEffect(()=>{

        const admin = checkPermission(GESTOR_DELEGACIONES_SERVICIOS);
        
        setHasAdminPermission(admin);

        if(!admin){
            navigate(PRIVATE_USER_LIST_DELEGATION_SERVICE, {replace: true});
        }
    },[checkPermission, navigate]);

    const actions = [
        {
            title: 'Delegación',
            to: PRIVATE_USER_DELEGATION,
            icon: <ManageAccountsIcon />,
            color: 'primary',
            description: 'Delegaciones'
        },
        {
            title: 'Empresa De Servicio',
            to: PRIVATE_USER_LIST_SERVICE_COMPANY,
            icon: <BusinessIcon />,
            color: 'primary',
            description: 'Empresa de Servicios'
        },
        {
            title: 'Gremio',
            to: PRIVATE_USER_LIST_UNION_DELEGATION_SERVICE,
            icon: <BusinessIcon />,
            color: 'primary',
            description: 'Empresa de Servicios'
        }
    ];

    return (
        <Box sx={{ p: 3 }}>
            <Box display="flex" alignItems="center" mb={1}>
                <IconButton size="small" onClick={() => navigate(DELEGATION_SERVICE)}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant="body2" sx={{ ml: 1, cursor: 'pointer' }} onClick={() => navigate(DELEGATION_SERVICE)}>Volver</Typography>
            </Box>
            <Typography variant="h5" mb={1}>Gestion De Servicios</Typography>
            <Typography variant="body1" color="text.secondary" mb={3}>
                Selecciona una acción para continuar.
            </Typography>
            <Grid container spacing={isStack ? 7 : 2}>
                {actions.map((a) => (
                    <Grid item xs={12} sm={isStack ? 12 : 6} md={isStack ? 12 : 3} key={a.title}>
                        <Paper elevation={2} sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <Box display="flex" alignItems="center" gap={1} mb={1}>
                                {a.icon}
                                <Typography variant="h6">{a.title}</Typography>
                            </Box>
                            <Typography variant="body2" color="text.secondary" mb={2}>{a.description}</Typography>
                            <Button
                                variant="contained"
                                color={a.color}
                                component={RouterLink}
                                to={a.to}
                                fullWidth={isStack}
                            >
                                Ir
                            </Button>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}